module.exports = __webpack_public_path__ + "static/media/skull_helmet.2370a5d6.png";